import BasicRtHero from './BasicRtHero';

export default BasicRtHero;
